import { render, staticRenderFns } from "./productstandardtable.vue?vue&type=template&id=c3985486&scoped=true&"
import script from "./productstandardtable.vue?vue&type=script&lang=js&"
export * from "./productstandardtable.vue?vue&type=script&lang=js&"
import style0 from "./productstandardtable.vue?vue&type=style&index=0&id=c3985486&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3985486",
  null
  
)

export default component.exports